enum IntegrationDeleteOptionEnum {
    DEACTIVATE = "deactivate",
    IGNORE = "ignore",
}

export default IntegrationDeleteOptionEnum;
